import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import Select from "@mui/material/Select";

export function OngoingDriveSelect({
  drives,
  selectedDriveId,
  onChange,
  loading,
  disabled,
  formatDriveStatus,
  minWidth = 280,
}) {
  const formatStatus =
    formatDriveStatus ||
    ((status) => {
      if (status === "onGoing") return "Ongoing";
      if (status === "pending") return "Upcoming";
      if (status === "completed") return "Completed";
      return status || "";
    });

  return (
    <FormControl
      size="small"
      sx={{ minWidth, backgroundColor: "#fff" }}
      disabled={disabled || loading || drives.length === 0}
    >
      <InputLabel id="ai-interview-drive-label">Drive</InputLabel>
      <Select
        labelId="ai-interview-drive-label"
        label="Drive"
        value={selectedDriveId || ""}
        onChange={(e) => onChange(e.target.value)}
      >
        {drives.length === 0 ? (
          <MenuItem value="" disabled>
            No drives available
          </MenuItem>
        ) : (
          drives.map((drive) => (
            <MenuItem key={drive.id} value={drive.id}>
              {drive.name}
              {drive.runningStatus
                ? ` (${formatStatus(drive.runningStatus)})`
                : ""}
            </MenuItem>
          ))
        )}
      </Select>
    </FormControl>
  );
}

export default OngoingDriveSelect;
